import React, {
    Component
} from 'react';
import {
    List,
    Flex
} from 'antd-mobile'

export default class Folding extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hide: true
        }
    }
    componentDidMount() {
      if (typeof this.props.hide !== 'undefined') {
          this.setState({hide: this.props.hide})
        }
    }

  toggle() {
        this.setState({
            hide: !this.state.hide
        }, () => {
            this.props.onChange && this.props.onChange(!this.state.hide)
        })
    }
    render() {
        return (
            <React.Fragment>
                <div style={{ display: this.state.hide ? 'none' : 'block' }}>
                    {this.props.children}
                </div>
                <List.Item onClick={this.toggle.bind(this)}>
                    <Flex justify="end" style={{ color: '#3e8fe7' }}>{this.state.hide ? '展开' : '隐藏'}</Flex>
                </List.Item>
            </React.Fragment>
        )
    }
}
